__turbopack_context__.v({
  "accent1": "WdobVa_accent1",
  "accent2": "WdobVa_accent2",
  "accent3": "WdobVa_accent3",
  "badges": "WdobVa_badges",
  "container": "WdobVa_container",
  "content": "WdobVa_content",
  "critical": "WdobVa_critical",
  "description": "WdobVa_description",
  "detailsLink": "WdobVa_detailsLink",
  "effortBadge": "WdobVa_effortBadge",
  "empty": "WdobVa_empty",
  "findingTitle": "WdobVa_findingTitle",
  "header": "WdobVa_header",
  "high": "WdobVa_high",
  "intro": "WdobVa_intro",
  "lastItem": "WdobVa_lastItem",
  "low": "WdobVa_low",
  "medium": "WdobVa_medium",
  "number": "WdobVa_number",
  "priorityReason": "WdobVa_priorityReason",
  "priorityRow": "WdobVa_priorityRow",
  "recommendation": "WdobVa_recommendation",
  "recommendationIcon": "WdobVa_recommendationIcon",
  "sectionLabel": "WdobVa_sectionLabel",
  "severityBadge": "WdobVa_severityBadge",
  "timeline": "WdobVa_timeline",
  "timelineItem": "WdobVa_timelineItem",
  "timelineNumber": "WdobVa_timelineNumber",
  "timelineTrack": "WdobVa_timelineTrack",
  "title": "WdobVa_title",
});
